import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'generateBomRadioButtonId',
    standalone: false
})
export class GenerateBomRadioButtonIdPipe implements PipeTransform {

  transform(id: number, isAccessories: boolean, isProjectComponent: boolean): string {
    return id.toString() + (isAccessories ? 'A' : isProjectComponent ? 'PC' : '');
  }

}
